// The theme person setting's DB title (its natural key).
export const APP_THEME_TITLE = 'APP_THEME';

// Display labels for settings whose DB Title is a code (seed migrations key on it), by Title;
// unlisted titles show as they are.
export const SETTING_TITLE_LABELS = {
	[APP_THEME_TITLE]: 'Theme'
};

export const CONSTANTS_SETTINGS = {
	PERSON_SETTING_TYPE: 'person',
	BOOKING_CONFIGURATION: 81,
	ACCESS_MODULE: 82,
	LOCKER_MODULE: 83,
	SCIM_TOKEN: 84,
	WORKSPACE_DOMAIN: 86,
	MASTER_CREDENTIAL: 87,
	ENABLE_CARD_ENROLMENT: 89,
	UNLOCK_METHOD: 90,
	ROOMS_CONFIGURATION: 91,
	ENFORCE_DOMAIN_CONTROL: 93,
	INNER_RANGE_MODULE: 94,
	IR_SETTING_LAST_SYNC: 108,
	IR_SETTING_SYNCING: 109,
	TTLOCK_MODULE: 110,
	TTLOCK_CLIENT_ID: 111,
	TTLOCK_CLIENT_SECRET: 112,
	TTLOCK_ACCOUNT: 113,
	TTLOCK_ACCESS_GROUPS: 114,
	TTLOCK_LOCKER_GROUPS: 115,
	TTLOCK_SETTING_LAST_SYNC: 121,
	TTLOCK_SETTING_SYNCING: 122,
	CONTROL_MODULE: 123,
	CONTROL_SETTING_LAST_SYNC: 125,
	CONTROL_SETTING_SYNCING: 126,
	CONTROL_LOCKS_GROUP_ID: 127,
	CONTROL_SYNC_LOCKS: 128,
	CONTROL_SYNC_RECORDS: 129,
	IR_LOG_SYNCING: 130,
	IR_LOG_LAST_SYNC: 131,
	CONTROL_LOG_SYNCING: 132,
	CONTROL_LOG_LAST_SYNC: 133,
	CONTROL_PASSCODE_LENGTH: 134,
	CONTROL_SYNC_PASSCODES: 135,
	// Connectivity sweep (Phase B). Seeded via migrations/add-connectivity-sweep.sql;
	// the settings UI auto-renders them in the Control group by fieldTypeID.
	// Gateway monitoring. 162 (check time) and 163 (last-check stamp) are retired and hidden
	// server-side; 164 is edited generically in Settings and read server-side, so no id is
	// needed here for it.
	GATEWAY_MONITORING_ENABLED: 161,
	ORG_TIMEZONE: 138, // org-local tz for the connectivity sweep cron
	ROOMS_MODULE: 136,
	PERMISSION_MODE: 139,
	VERKADA_MODULE: 140,
	// 141/142/143 are the Verkada CREDENTIALS, and NOTHING in the frontend reads them.
	// They are named here only so the next person can see what those ids are without
	// digging through the server's constants.
	//
	// Minting the streaming token in the browser was tried on 2026-09-07 and cannot work:
	// `x-api-key` triggers a CORS preflight and Verkada answers OPTIONS with 403 and no
	// Access-Control-Allow-Origin. Live view goes through POST /cameras/:deviceID/
	// stream-token — see the note on loadStream in reduxStore/cameras/saga.js.
	//
	// 🛑 142 is an ORG-WIDE API key with no per-site or per-camera scope, and GET /settings
	// still returns it unredacted, so it sits in every dashboard user's redux store today.
	// Nothing here put it there and nothing here needs it — but do not build on it.
	VERKADA_ORG_ID: 141,
	VERKADA_API_KEY: 142,
	VERKADA_REGION: 143,
	VERKADA_SETTING_LAST_SYNC: 144,
	VERKADA_SETTING_SYNCING: 145,
	VORTEX_MODULE: 149,
	VORTEX_SETTING_LAST_SYNC: 152,
	VORTEX_SETTING_SYNCING: 153,
	CAMERA_THUMBNAIL_REFRESH_SECONDS: 156,
	CAMERA_IDLE_PAUSE_SECONDS: 157,
	// 159 = BOOKING_APPROVAL_MODE (seeded in App Server). 160 = the Bookings product
	// operational flag (DefaultSettingID seeded in App Server booking migration).
	BOOKINGS_MODULE: 160,
	// Inception (SettingGroup 38; 166-176 seeded by add-inception-integration.sql)
	INCEPTION_MODULE: 166,
	INCEPTION_SETTING_LAST_SYNC: 170,
	INCEPTION_SETTING_SYNCING: 171,
	// Vision (SettingGroup 40; 195 seeded by add-vision-module.sql)
	VISION_MODULE: 195,
	// Microsoft 365 (SettingGroup 42; 214-221 seeded by add-m365-integration.sql).
	// Mirroring is event-driven (no manual sync), so no *_SYNCING constant — only the
	// module toggle and the reserved last-sync display id.
	M365_MODULE: 214,
	M365_SETTING_LAST_SYNC: 219,
	// Visitor Management (SettingGroup 43; 223 seeded by add-visitor-management-module-setting.sql).
	VISITOR_MANAGEMENT_MODULE: 223,
	// Authoring-only toggle, not a module switch: while off, an org may not create a NEW org-wide
	// (global) guest type — existing ones and the module itself are unaffected. Default off (most
	// orgs run one site). 224 seeded by add-visitor-type-global-scope-setting.sql.
	VISITOR_TYPE_GLOBAL_SCOPE: 224,
	// Shelly Presence (SettingGroup 44; 226 seeded by the App Server's add-shelly-presence.sql). Ingest is
	// refused for an org with this off. 227 (the ingest-secret hash) is internal and never read here.
	SHELLY_MODULE: 226
};
